import { useState } from "react";
import { ListingsHomeTab } from "../listings/ListingsHomeTab";
import { ListingsListingsTab } from "../listings/ListingsListingsTab";
import { ListingsProfileTab } from "../listings/ListingsProfileTab";
import "./Listings.scss";

type ListingsTabKey = "home" | "listings" | "reports" | "profile";

const TABS: { key: ListingsTabKey; label: string }[] = [
  { key: "home", label: "Home" },
  { key: "listings", label: "Listings" },
  { key: "reports", label: "Reports" },
  { key: "profile", label: "Profile" },
];

export default function Listings() {
  const [activeTab, setActiveTab] = useState<ListingsTabKey>("home");

  return (
    <div className="listings-page">
      <header className="listings-page-header">
        <h1>Listings</h1>
      </header>

      <nav className="listings-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`listings-tab${activeTab === t.key ? " active" : ""}`}
            onClick={() => setActiveTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <div className="listings-tab-content">
        {activeTab === "home" && <ListingsHomeTab />}
        {activeTab === "listings" && <ListingsListingsTab />}
        {activeTab === "reports" && <div className="listings-placeholder">Reports — coming soon</div>}
        {activeTab === "profile" && <ListingsProfileTab />}
      </div>
    </div>
  );
}
